import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useCreditCheckFollowupBoxStyles = makeStyles({
    followupContainer: {
        ...shorthands.borderRadius(tokens.borderRadiusMedium),
        ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingVerticalM),
        ...shorthands.margin(tokens.spacingVerticalM, 'auto'),
        width: '75%',
        marginLeft: '0',
        '@media screen and (max-width: 480px)': {
            width: '100%'
        }
    },
    header: {
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.fontSizeBase500,
        marginBottom: tokens.spacingVerticalM
    },
    fadedBodyText: {
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.fontSizeBase300,
        opacity: '75%'
    },
    informationalStatus: {
        backgroundColor: tokens.colorBrandForeground2
    },
    phoneNumberInput: {
        width: '40%'
    },
    callMeInfoText: {
        ...shorthands.margin('0', 'auto', tokens.spacingVerticalS, 'auto')
    },
    callMeButton: {
        ...shorthands.padding('0', tokens.spacingHorizontalXL)
    },
    callMeButtonIcon: {
        color: 'white',
        height: '16px',
        ...shorthands.margin(
            tokens.spacingHorizontalS,
            tokens.spacingHorizontalS,
            tokens.spacingHorizontalS,
            '0'
        )
    },
    viewCartButton: {
        width: '20%'
    },
    completedStatus: {
        backgroundColor: tokens.colorPaletteGreenBackground1,
        justifyContent: 'start'
    },
    completedIcon: {
        color: tokens.colorPaletteGreenForeground2,
        height: '32px',
        ...shorthands.margin('auto', tokens.spacingHorizontalL, 'auto', tokens.spacingHorizontalS)
    }
});

export default useCreditCheckFollowupBoxStyles;
